import { useState } from "react";
// Components
import NewStaffDialog from "./SelectStaffNewStaffDialog";
import { ComponentAuthorisation } from "../../components/ComponentAuthorisation";
// MUI
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
// import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import { Stack } from "@mui/material";

export const SelectStaffDialog = ({
  children,
  handleStaffSelection,
  clearStaffSelection,
}) => {
  const [open, setOpen] = useState(false);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  const handleClickOpen = () => {
    clearStaffSelection();
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleSelect = () => {
    handleStaffSelection();
    setOpen(false);
  };

  return (
    <Box>
      <Button variant="contained" size="large" onClick={handleClickOpen}>
        Select Staff
      </Button>
      <Dialog
        fullScreen={fullScreen}
        fullWidth={true}
        maxWidth={"xl"}
        open={open}
        onClose={handleClose}
        aria-labelledby="select-staff-dialog"
      >
        <Stack
          direction="row"
          spacing={2}
          sx={{
            justifyContent: "space-between",
            alignItems: "center",
            mr: 3,
          }}
        >
          <DialogTitle id="select-staff-dialog-title">Select Staff</DialogTitle>
          <ComponentAuthorisation allowedRoles={["staffCreate"]}>
            <NewStaffDialog />
          </ComponentAuthorisation>
        </Stack>
        <DialogContent>
          <Stack spacing={2}>{children}</Stack>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button onClick={handleSelect}>Select</Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};
